export default "__VITE_ASSET__rBkuzBll__"